// Great Red Spot (Jupiter): the star nearest each planet of the sky scores
// more, when a constellation uses it.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { nearestStars } from '../shared/geometry';
import type { AlignmentDef } from '../types';

export const greatRedSpot: AlignmentDef = {
  id: 'great-red-spot',
  planet: 'jupiter',
  name: 'Great Red Spot',
  text: () => `The star nearest each planet scores +${N.greatRedSpotPercent}%.`,
  starPercent: (star, _c, ctx) => (nearestStars(ctx).has(star.node.id) ? N.greatRedSpotPercent : 0),
};
